// extracted by mini-css-extract-plugin
module.exports = {"container":"TextInput_container__Xw7w_","fullWidth":"TextInput_fullWidth__ZjP9E","input":"TextInput_input__A4Mgs","disabled":"TextInput_disabled__rFCJc"};